export default __webpack_public_path__ + "static/media/europeana-logo.f2ad3d51.png";